import { KYMW1400Model } from '../kymw1400.model';
import { KomaIDModel } from '../vo/koma-id.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コマ情報取得コマンド
 *
 * @export
 * @class GetKomaService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetKomaService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW1400Model = null;
  private vo: KomaIDModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetKomaService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        KomaID: this.vo.komaID,
        MediumType: this.vo.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1400Model} model モデルクラス
   * @param {KomaIDModel} vo パラメータ
   * @memberof GetKomaService
   */
  execute(model: KYMW1400Model, vo: KomaIDModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14getKoma', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetKomaService
   */
  success(data: any) {
    // コマ情報追加
    this.model.selectedPage.updateKomaData(data);

    // ページ情報取得要求(/KYMW14/getPage.xml)をサーバに送信する。
    this.model.kymw1400Component.dispatchGetPlanSummaryTableEvent();
  }
}
